import React, {Component} from 'react';
import propTypes from "prop-types";
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as Actions from '../actions';

//import components
import MainPageSeparator from '../components/main-page/MainPageSeparator.js';
import MainPageNews from '../components/main-page/MainPageNews.js';
import MainPagePos from '../components/main-page/MainPagePos.js';
import MainPagePblNumbers from '../components/main-page/MainPagePblNumbers.js';
import MainPageWhatInPbl from '../components/main-page/MainPageWhatInPbl.js';
import LoadingIndicator from '../components/LoadingIndicator.js';

import withTitle from '../scripts/WithTitle.js';

class MainPage extends Component {
    componentDidMount() {
        const {actions, clang} = this.props;

        actions.getNewsMainPage(clang);
        actions.getPosMainPage(clang);
        actions.getWhatInPbl(clang);
        actions.getPblNumber();
    };

    componentWillReceiveProps(nextProps) {
        const { actions, clang } = this.props;

        if (clang !== nextProps.clang) {
            actions.getNewsMainPage(nextProps.clang);
            actions.getPosMainPage(nextProps.clang);
            actions.getWhatInPbl(nextProps.clang);
        }
    };

    render() {
        const { news, pos, isNewsError, isPosError, isFetchingNews, isFetchingPos, isPblNumberError,
                isFetchingPblNumber, pblNumber, isWhatInPblError, isFetchingWhatInPbl, whatInPbl} = this.props;

        return (
            <section className="main">
                {(isFetchingNews || isFetchingPos || isFetchingPblNumber || isFetchingWhatInPbl) &&
                    <LoadingIndicator />}
                {!isFetchingNews && !isFetchingPos && !isFetchingPblNumber && !isFetchingWhatInPbl &&
                    <div>
                        {!isWhatInPblError && <MainPageSeparator />}
                        {!isWhatInPblError && whatInPbl.length > 0 && <MainPageWhatInPbl data={whatInPbl}/>}
                        {!isPosError && <MainPageSeparator />}
                        {!isPosError && <MainPagePos data={pos}/>}
                        {!isPblNumberError && <MainPagePblNumbers data={pblNumber}/>}
                        {!isNewsError && news.length > 0 && <MainPageNews data={news}/>}
                    </div>}
            </section>
        );
    };
};

MainPage.propTypes = {
    clang: propTypes.string.isRequired,
    actions: propTypes.object.isRequired,
    news: propTypes.arrayOf(propTypes.object),
    pos: propTypes.object,
    whatInPbl: propTypes.arrayOf(propTypes.object),
    pblNumber: propTypes.arrayOf(propTypes.object),
    isFetchingNews: propTypes.bool.isRequired,
    isFetchingPos: propTypes.bool.isRequired,
    isFetchingPblNumber: propTypes.bool.isRequired,
    isFetchingWhatInPbl: propTypes.bool.isRequired,
    isNewsError: propTypes.bool.isRequired,
    isPosError: propTypes.bool.isRequired,
    isPblNumberError: propTypes.bool.isRequired,
    isWhatInPblError: propTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    news: state.mainPage.news,
    pos: state.mainPage.pos,
    whatInPbl: state.mainPage.whatInPbl,
    pblNumber: state.mainPage.pblNumber,
    isFetchingNews: state.mainPage.isFetchingNews,
    isFetchingPos: state.mainPage.isFetchingPos,
    isFetchingPblNumber: state.mainPage.isFetchingPblNumber,
    isFetchingWhatInPbl: state.mainPage.isFetchingWhatInPbl,
    isWhatInPblError: state.mainPage.isWhatInPblError,
    isNewsError: state.mainPage.isNewsError,
    isPosError: state.mainPage.isPosError,
    isPblNumberError: state.mainPage.isPblNumberError,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withTitle,
);

export default enhance(MainPage);



// WEBPACK FOOTER //
// ./src/containers/MainPage.js